import React from "react";


import { connect } from "react-redux";
import CommonTitleHeader from "../commonTitleComponent/commonTitleHeader";
import Footer from "../footerComponent/Footer";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import BankSteps from "./BankSteps";
import BankToBankTransferDetails from "./BankToBankTransferDetails";
import PaymentFillUp from "./PaymentFillUp";
import PaymentFilter from "./PaymentFilter";
import PaymentStaticTxt from "./PaymentStaticTxt";


class ManagePayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,

        }
    }


    componentDidMount() { }
    componentWillUnmount() {
    }




    render() {
        console.log('Inside render');
        var headerTitle = "Payment Details";
        return (
            <div>
                <div class="main">
                    <LeftMenu />

                    <div class="right-side">
                        <div class="container-fluid">

                            <Header />
                            <PaymentFillUp />

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(ManagePayment);
